import actions from "./moduleLogoActions.js";
export default {
  namespaced: true,
  actions: actions,
};